import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";

import "./styles.css";
import { makeUnauthorizedHandler } from "./auth/unauthorized";
import { LocaleProvider } from "./i18n/index.js";
import { setUnauthorizedHandler } from "./lib/http";
import { router } from "./router";
import { ThemeProvider } from "./theme/ThemeProvider";

// The app's single reaction to a lapsed `loom_session` cookie
// (`auth/unauthorized.ts`): drop the shared `/auth/me` answer, then a soft
// navigation to /sign-in.
setUnauthorizedHandler(makeUnauthorizedHandler(router));

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root in index.html");
}
createRoot(container).render(
  <React.StrictMode>
    <ThemeProvider>
      <LocaleProvider>
        <RouterProvider router={router} />
      </LocaleProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
